<template>
  <div class="container">
    <div class="row px-2 mb-2">
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text" id="basic-addon1"><span v-text="_trans('Search for:')"></span> <span>{{column}}</span></span>
        </div>
        <input type="text" v-model="basesearch" class="form-control" v-focus aria-label="SearchFor" aria-describedby="basic-addon1" :placeholder="_trans('Search Text')" @keypress.enter="search()">
        <div class="input-group-append">
          <span class="input-group-text btn btn-outline-primary" @click="search()"><i class="di di-search"></i></span>
          <span v-if="params && params.Table" class="input-group-text btn btn-warning" @click="dofollow()">➦</span>
        </div>
      </div>
      </div>
      <d-table :rows="rows" :columns="cols" bottom="1" @sorttable="sort($event)" @scrolltoend="loadmore()" @select="select($event)" :cansort="xfull" :searchtext="searchtext" ></d-table>
  </div>
</template>

<script>
import { NextApiClient } from '@3cad/nextcore'
import { bus } from '@store/dau'

export default {
    data () {
        return {
            cols: [],
            rows: [],
            title: '',
            hasmore: false,
            page: 1,
            corder: '',
            cWhere: '',
            column: '*',
            basesearch: undefined,
            currentrow: -1,
            retfull: false
        }
    },
    computed: {
        preferences () {
            return this.$store.getters['getPreferences']
        },
        elepage () {
            if (this.full) return 10000
            return this.preferences.config.searchrowsxpage || 40
        },
        searchtext () {
            return this.xfull ? this.basesearch : null
        },
        xfull () {
            return this.full || this.retfull
        }
    },
    props: {
        service: String,
        func: String,
        params: Object,
        full: Boolean  // ritorna tutti gli oggetti su una singola pagina
    },
    watch: {
        params (newval, oldval) {
            if (oldval) {
                if (JSON.stringify(oldval) != JSON.stringify(newval) || this.rows.length === 0) this.loadpage(1)
            } else {
                this.loadpage(1)
            }
        }
    },
    mounted () {
        this.loadpage(1)
    },

    methods: {
        reloadcurrent () {
            var sc = this
            if (sc.currentrow > 0 && sc.rows.length > sc.currentrow) {
                var p = {}
                if (sc.params) p = Object.assign({}, sc.params)
                p.Page = 1
                p.Rows = 1
                p.cOrder = ''
                p.cWhere = '0:' + sc.rows[sc.currentrow][sc.cols[0].id]
                var func = sc.func ? sc.func : 'HelperSearch'
                var service = sc.service ? sc.service : 'helpers'
                NextApiClient.com(service, func, p, function (d) {
                    if (d.data && d.data.records && d.data.records[0]) {
                        var id = sc.rows[sc.currentrow].RecordId
                        sc.rows[sc.currentrow] = d.data.records[0]
                        sc.rows[sc.currentrow].RecordId = id
                    }
                }, err => {
                    throw err
                })
            }
        },
        loadpage (id, cod, callback) {
            var sc = this
            var p = {}
            if (sc.params) p = Object.assign({}, sc.params)
            var func = sc.func ? sc.func : 'HelperSearch'
            var service = sc.service ? sc.service : 'helpers'
            if (cod) {
                p.Page = 1
                sc.page = 1
                p.Rows = 1
                p.cOrder = ''
                p.cWhere = '0:' + cod
            } else {
                p.Page = id
                p.Rows = sc.elepage
                sc.page = id
                p.cOrder = sc.corder
                p.cWhere = sc.cWhere
            }
            if (!p.Table && func == 'HelperSearch') {  //BUG fix
                return
            }

            NextApiClient.com(service, func, p, d => {
                if (cod && callback) {
                    if (d.data && d.data.records && d.data.records.length > 0) {
                        callback(d.data.records[0])
                    }
                } else {
                    sc.title = d.info.title
                    sc.retfull = d.full
                    if (id < 2) {
                        sc.cols.splice(0, sc.cols.length)
                        sc.rows.splice(0, sc.rows.length)
                        sc.currentrow = -1
                        d.head.columns.forEach(e => {
                            var w = parseInt(e.width)
                            if (e.type == 'H') w = 0
                            sc.cols.push({
                                id: e.field,
                                title: e.caption,
                                w: w,
                                style: e.type
                            })
                        })
                    }

                    if (d.data) {
                        sc.hasmore = d.data.total > sc.elepage && !sc.xfull
                        d.data.records.forEach((e, i) => {
                            if (i < sc.elepage || sc.xfull) {
                                sc.rows.push(e)
                            }
                        })
                    } else {
                        sc.hasmore = false
                    }
                }
            }, err => {
                throw err
            })
        },
        sort (col) {
            var sc = this
            sc.column = col.col
            if (col.col != null) {
                sc.cols.forEach((e, i) => {
                    if (e.id == col.col) {
                        sc.corder = i + ''
                        if (!col.asc) sc.corder += 'D'
                        sc.loadpage(1)
                    }
                })
            } else {
                sc.cWhere = ''
                sc.corder = ''
                sc.loadpage(1)
            }
        },
        loadmore () {
            if (this.hasmore && !this.xfull) {
                this.loadpage(this.page + 1)
            }
        },
        search () {
            if (!this.xfull) {
                var ss = this.basesearch
                if (ss) {
                    if (ss.indexOf('%') < 0) ss = '%' + ss + '%'

                    if (this.corder) {
                        this.cWhere = this.corder.slice(0, 1) + ':' + ss
                    } else {
                        this.cWhere = '*:' + ss
                    }
                } else {
                    this.cWhere = ''
                }
                this.loadpage(1)
            }
        },
        select (r) {
            this.currentrow = r
            this.$emit('select', this.rows[r])
        },
        dofollow () {
            var sc = this
            bus.$emit('routeadd', {cod: 'helperconfig.' + this.params.Table})
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/_eng/globals/dsearch.vue